// Service des appels backend de la fenetre de parametrage des tables (ParametrageTable.vue).
// Porte la fenetre desktop frmpartab.cs (TransCAM_Library).
// Contrat documente dans docs/plans/2026-07-02-parametrage-tables-design.md.
import config from "../config.js";
import RequestManager from "./request.js";

export default class TablesParam {

    // Charge une table par typpar -> { titre, colonnes, lignes, readOnly }.
    static chargerTable(typpar) {
        const url = `${config.urlBackEnd}Param/table?typpar=${encodeURIComponent(typpar)}`;
        return RequestManager.get(url);
    }

    // Enregistre les lignes editees (equivalent UpdateDataTable + pose FORCAGE cote serveur).
    // -> { success, message }
    static enregistrerTable(typpar, lignes) {
        const url = `${config.urlBackEnd}Param/table`;
        return RequestManager.post(url, { typpar: Number(typpar), lignes });
    }

    // Export CSV cote front (port Btexporter_Click) : separateur ';', entete = libelles.
    // colonnes = [{cle, libelle}], lignes = [{...}]. Telecharge un fichier Export<cle>.csv.
    static exporterCSV(nomTable, colonnes, lignes) {
        const sep = ";";
        const echappe = (v) => {
            const s = (v === null || v === undefined) ? "" : String(v);
            // Entoure de guillemets si le contenu porte le separateur, un guillemet ou un saut de ligne.
            return /[";\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
        };
        const entete = colonnes.map(c => echappe(c.libelle)).join(sep);
        const corps = lignes.map(l => colonnes.map(c => echappe(l[c.cle])).join(sep)).join("\r\n");
        const contenu = entete + "\r\n" + corps;
        this.telechargerTexte(contenu, "Export" + nomTable + ".csv");
    }

    // Declenche le telechargement navigateur d'un contenu texte CSV (iso-8859-1 comme le desktop).
    static telechargerTexte(contenu, nomFichier) {
        const blob = new Blob([contenu], { type: "text/csv;charset=iso-8859-1" });
        const lien = document.createElement("a");
        lien.href = URL.createObjectURL(blob);
        lien.download = nomFichier;
        document.body.appendChild(lien);
        lien.click();
        document.body.removeChild(lien);
        URL.revokeObjectURL(lien.href);
    }
}
